import { render, staticRenderFns } from "./DeliveryResponse.vue?vue&type=template&id=3707efac&scoped=true&"
import script from "./DeliveryResponse.vue?vue&type=script&lang=ts&"
export * from "./DeliveryResponse.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryResponse.vue?vue&type=style&index=0&id=3707efac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3707efac",
  null
  
)

export default component.exports